import { Deserializer } from 'ts-jsonapi';

export const deserializer = new Deserializer({
  keyForAttribute: 'camelCase',
  nullIfMissing: true
});
